import { render, staticRenderFns } from "./TipoLicenciaModalEdicion.vue?vue&type=template&id=963bbeb6&scoped=true&"
import script from "./TipoLicenciaModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./TipoLicenciaModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./TipoLicenciaModalEdicion.vue?vue&type=style&index=0&id=963bbeb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963bbeb6",
  null
  
)

export default component.exports